import { cmToInch, generateLegend, heading1_text, heading1_css, rect, estimateTextHeight } from "./commonFunctions";
import { getDistinctValues, removeHtmlTags } from "../../util";

const insightsIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAdCAMAAACt1K3WAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAGBQTFRF////ra2tW1tbjIyM/Pz8UFBQj4+PpaWlf39/e3t7CQkJqqqqSkpKpKSkv7+/g4ODHh4e5ubmSEhI29vbyMjIHx8f2NjYHR0dy8vLzMzM3Nzc5+fnp6enTk5OWlpawMDAyom9OgAAAHNJREFUeJxjZEABjDi4jP9RuEyMf5G5LIyMv0BcdqgIIyPjVyCXh5ERxn0P5AoxvgXxRBgZX4EU87CDueKML8BGQWVh9g5OLszNTM+RZSX/sD5jQPYvB8tTlNAQeoIUVpIvfyEFndxTlJCUf8jAgDsWIAAAnz4gHsda/i4AAAAASUVORK5CYII='

// PPtx With Direct Data Without DOM Manipulation
// Final integrated version with consistent row spacing per row (based on tallest brand content in that row)
// Uses estimateTextHeight() to dynamically measure per-insight height
export function generateFactorInterlinkage(dataa, pptx, pres, isAppendices) {
  const distinctCategory = getDistinctValues(dataa.content.linksDetails.map(d => d.source))
  const distinctSourceColors = dataa.content.linksDetails.map(d => ({
    category: d.category,
    source: d.source,
    color: dataa.content.legend[d.category.replaceAll(' ', '')]
  }))

  const distinctArray = distinctCategory.map(d => dataa.content.linksDetails.find(f=> f.source === d)).map(d => ({
    source: d.source,
    sourceColor: distinctSourceColors.find(f=> f.source === d.source)?.color,
    data: d.rest.FactorLinkages.FactorLinkage.map(d1 => ({
      name: d1.LinkedFactor,
      value: d1.LinkageWeight,
      category: distinctSourceColors.find(f=> f.source === d1.LinkedFactor)?.category,
      color: distinctSourceColors.find(f=> f.source === d1.LinkedFactor)?.color,
      insights: d1.Insights
    }))
  }))

  const finalData = {
    ...dataa.content,
    distinctArray: distinctArray
  }

  for(let i=0; i<finalData.distinctArray.length; i++){
    const objData = finalData.distinctArray[i]
    objData.pageTitle = dataa.Title

    if(objData?.data?.length > 1){
      generateInsights(dataa.Title, objData, objData.data, pres)

      const slide = pres.addSlide({ masterName: 'MASTER_SLIDE' });
      generateChart(dataa.Title, objData, objData.data, pres, slide, dataa.content.legend)
    }
  }
 
}

const generateSingleInsight = (slide, pptx, fullObject, object) => {
  const posiX = rect.x;
  const posiY = object.y;

  const percentCircleSize = 0.5;
  slide.addShape(pptx.ShapeType.ellipse, {
    x: posiX,
    y: posiY,
    w: percentCircleSize,
    h: percentCircleSize,
    fill: { color: "FFFFFF" },
    line: { color: "000000", width: 0.5 },
  });
  slide.addText(`${object.value}%`, {
    x: posiX - 0.1,
    y: posiY,
    w: percentCircleSize + 0.2,
    h: cmToInch(1.3),
    fontSize: 13,
    color: "000000",
    align: "center",
    valign: "middle",
  });
  slide.addText(`${fullObject.source}\n${object.name}`, {
    x: posiX + percentCircleSize + 0.2,
    y: posiY,
    w: rect.w - percentCircleSize - 0.1,
    h: cmToInch(1.3),
    fontSize: 13,
    color: "000000",
    align: "left",
    valign: "top",
  });
  slide.addText(removeHtmlTags(object.insights), {
    x: posiX,
    y: posiY + cmToInch(1.35),
    w: rect.w - 0.1,
    // h: cmToInch(1.3),
    fontSize: 13,
    color: "000000",
    align: "left",
    valign: "top",
  });

  slide.addImage({ path: insightsIcon, x: posiX+percentCircleSize+0.1, y: posiY+0.1, w: cmToInch(0.37), h: cmToInch(0.77) });
  
}

const generateInsights = (pageTitle, fullObject, data, pres) => {
  const insightsData = []
  const finalData = data.filter(f => f.insights && f.insights.trim() !== '' && f.insights.length > 0)
  if(finalData.length === 0) return;
  for(let i=0;i<finalData.length;i++){
    let y = 0
    if(i===0) { y = rect.y + cmToInch(0.8) }
    else {
      // NOTE: All the calc should be in INCHES
      // const calc = 0.5 + estimateTextHeight(insightsData[i].Insights);
      const str = removeHtmlTags(insightsData[i-1].insights).replaceAll('&nbsp;', ' ').replaceAll('&nbsp;', ' ')
      const calc = cmToInch(1.7) + estimateTextHeight(str, rect.w - 1).height;
      y = insightsData[i-1].y + calc
    }

    insightsData.push({
      ...finalData[i],
      y: y
    })
  }
  

  const slide = pres.addSlide({ masterName: 'MASTER_SLIDE' });
  slide.addText(heading1_text(pageTitle), heading1_css(pageTitle))
  
  slide.addText(fullObject.source, {
    x: rect.x,
    y: rect.y,
    w: rect.w,
    h: cmToInch(0.7),
    fontSize: 14,
    color: "000000",
    align: "left",
    valign: "top",
    bold: true,
  });
  
  for(let i=0;i<insightsData.length;i++){
    const d = insightsData[i]
    generateSingleInsight(slide, pres, fullObject, d)
  }


  
  // return false

  // const slide = pres.addSlide({ masterName: 'MASTER_SLIDE' });
  // // override angles based on data length

  // slide.addText(heading1_text(pageTitle), heading1_css(pageTitle))

  // slide.addText(`
  //   Percentages indicate the degree of overlap between the two insight spaces, Size of the circles indicate the category engagement of the insight space (relative to importance of insight spaces in the category)
  // `, {
  //   x: cmToInch(1.29),
  //   y: cmToInch(16.35),
  //   w: cmToInch(31.7),
  //   h: cmToInch(0.65),
  //   fontSize: 9,
  //   color: "000000",
  //   align: "left",
  // });
};







const settings = {
  centerX: 6.5,
  centerY: 4.8,
  centerRadius: 1.15 * 0.33,
  bigCircleRadius: (0.7 * 0.6) * 0.85,
  orbitRadius: 2.5,

  // default angles (will often get overwritten)
  startAngle: 140,
  endAngle: 400,

  bottomGapDeg: 20,
  bottomGapPx: 0,

  edgeScale: 0.7,
  centerScale: 1.4,
  scaleCurvePower: 3.2,
};

/**
 * Pick angle ranges based on number of data points.
 * - If n ≥ 8 → full range 140..400 (span = 260°)
 * - If n ≤ 3 → narrow range 230..310 (span = 80°)
 * - Between 4 and 7 → interpolate linearly between those ranges
 */
function getAngleRangeForCount(n) {
  const maxCount = 8;
  const minCount = 3;
  // extreme ranges:
  const maxRange = { startAngle: 140, endAngle: 400 };  // span = 260°
  const minRange = { startAngle: 230, endAngle: 310 };  // span = 80°

  if (n >= maxCount) {
    return maxRange;
  }
  if (n <= minCount) {
    return minRange;
  }
  // interpolate linearly for n in (minCount, maxCount)
  // find fraction t from 0..1 where 0 → minRange, 1 → maxRange
  const t = (n - minCount) / (maxCount - minCount);
  return {
    startAngle: minRange.startAngle + t * (maxRange.startAngle - minRange.startAngle),
    endAngle: minRange.endAngle + t * (maxRange.endAngle - minRange.endAngle),
  };
}

const generateChart = (pageTitle, fullObject, data, pptx, slide, legend) => {
  // override angles based on data length
  const autoRange = getAngleRangeForCount(data.length);
  const localSettings = {
    ...settings,
    startAngle: autoRange.startAngle,
    endAngle: autoRange.endAngle,
  };
  if(data.length > 9) {
    localSettings.orbitRadius = 2.8
  } 

  const {
    centerX, centerY,
    centerRadius: baseCenterRadius,
    bigCircleRadius: baseBigCircleRadius,
    orbitRadius,
    startAngle, endAngle,
    bottomGapDeg, bottomGapPx,
    edgeScale, centerScale, scaleCurvePower
  } = localSettings;

  // optional extra reduction
  const centerRadius = baseCenterRadius * 1.10;
  const bigCircleRadius = baseBigCircleRadius * 0.85;

  slide.addText(heading1_text(pageTitle), heading1_css(pageTitle))

  // draw center circle & title // Pink circle
  slide.addShape(pptx.ShapeType.ellipse, {
    x: centerX - centerRadius,
    y: centerY - centerRadius,
    w: centerRadius * 2,
    h: centerRadius * 2,
    fill: { color: "FFFFFF" },
    line: { color: fullObject.sourceColor.replace('#',''), width: 5.5 },
  });
  //BLACK DOT CIRCLE
  slide.addShape(pptx.ShapeType.ellipse, {
    x: centerX - centerRadius + 0.32,
    y: centerY - centerRadius + 0.32,
    w: cmToInch(0.5),
    h: cmToInch(0.5),
    fill: { color: "000000" },
  });
  slide.addText(fullObject.source, {
    x: centerX - 1,
    y: centerY + centerRadius,
    w: 2,
    h: 0.6,
    align: "center",
    fontSize: 14,
    bold: true,
  });

  generateLegend(pptx, slide, '', legend)
  
  slide.addText(`
    Percentages indicate the degree of overlap between the two insight spaces, Size of the circles indicate the category engagement of the insight space (relative to importance of insight spaces in the category)
  `, {
    x: cmToInch(1.29),
    y: cmToInch(16.35),
    w: cmToInch(31.7),
    h: cmToInch(0.65),
    fontSize: 9,
    color: "000000",
    align: "right",
    valign: "middle",      // **add this** if library supports “valign” or “verticalAlign”
  });


  // convert to radians
  const startRad = (startAngle * Math.PI) / 180;
  const endRad = (endAngle * Math.PI) / 180;

  let gapRad = (bottomGapDeg * Math.PI) / 180;
  if (bottomGapPx > 0) {
    const circumference = 2 * Math.PI * orbitRadius;
    const gapDegFromPx = (bottomGapPx / circumference) * 360;
    gapRad = (gapDegFromPx * Math.PI) / 180;
  }

  const usableStart = startRad + gapRad / 2;
  const usableEnd = endRad - gapRad / 2;
  const arcSpan = usableEnd - usableStart;

  if (data.length < 2) {
    console.log("Need at least 2 data points for positioning");
  }
  const angleStep = arcSpan / (data.length - 1);
  const midAngle = (usableStart + usableEnd) / 2;

  data.forEach((d, i) => {

    const angle = usableStart + i * angleStep;

    const halfSpan = arcSpan / 2;
    let dist = Math.abs(angle - midAngle) / halfSpan;
    dist = Math.min(Math.max(dist, 0), 1);

    const curve = Math.pow(dist, scaleCurvePower);
    const scale = centerScale * (1 - curve) + edgeScale * curve;

    const thisRadius = bigCircleRadius * scale;
    const x = centerX + orbitRadius * Math.cos(angle);
    const y = centerY + orbitRadius * Math.sin(angle);

    const startX = centerX + centerRadius * Math.cos(angle);
    const startY = centerY + centerRadius * Math.sin(angle);
    const endX = x - thisRadius * Math.cos(angle);
    const endY = y - thisRadius * Math.sin(angle);
    const midX = (startX + endX) / 2;
    const midY = (startY + endY) / 2;

    slide.addShape(pptx.ShapeType.custGeom, {
      x: 0,
      y: 0,
      line: { color: "000000", width: 2 },
      points: [
          { x: startX, y: startY },
          { x: midX, y: midY },
          { x: endX, y: endY },
      ],
    });



    const percentCircleSize = 0.3;
    slide.addShape(pptx.ShapeType.ellipse, {
      x: midX - percentCircleSize / 2,
      y: midY - percentCircleSize / 2,
      w: percentCircleSize,
      h: percentCircleSize,
      fill: { color: "FFFFFF" },
      line: { color: "000000", width: 0.5 },
    });
    slide.addText(`${d.value}%`, {
      x: midX - 0.25,
      y: midY - 0.12,        // this will be adjusted
      w: 0.5,
      h: cmToInch(0.63),
      fontSize: 9,
      color: "000000",
      align: "center",
      valign: "middle",      // **add this** if library supports “valign” or “verticalAlign”
    });

    const words = d.name.split(" ");
    const labelText =
      words.length > 2
        ? words.slice(0, 2).join(" ") + "\n" + words.slice(2).join(" ")
        : d.name;


    const ε = 1e-6;  // small tolerance
    const isAtCenter =
      Math.abs(x - centerX) < ε && Math.abs(y - centerY) < ε;

    if (isAtCenter) {
      // place text above the circle, centered horizontally
      slide.addText(labelText, {
        x: x - 1,  // assuming text width ~2, so shift left by ~half width
        y: y - thisRadius - 0.4,  // slightly above the circle
        w: 2,
        h: 0.5,
        fontSize: 12,
        align: "center",
        valign: "top",
      });
    } else {
      const isLeft = x < centerX;
      if (isLeft) {
        slide.addText(labelText, {
          x: x - thisRadius - 2,
          y: y - percentCircleSize / 2,
          // y: y + (percentCircleSize/2),
          w: 2,
          h: 0,
          fontSize: 12,
          align: "right",
          valign: "top",
        });
      } else {
        slide.addText(labelText, {
          x: x + thisRadius,
          y: y - percentCircleSize / 2,
          // y: y,
          w: 2,
          h: 0,
          fontSize: 12,
          align: "left",
          valign: "top",
        });
      }
    }

    // this was the BLUE circle
    slide.addShape(pptx.ShapeType.ellipse, {
      x: x - thisRadius,
      y: y - thisRadius,
      w: thisRadius * 2,
      h: thisRadius * 2,
      fill: { color: "FFFFFF" },
      line: { color: d.color, width: 4 },
    });

  });
};







